import { create } from 'zustand';

interface PrevalenceBreakdownState {
  prevalenceBreakdownRow: any;
  setPrevalenceBreakdownRow: (row: any) => void;
}

export const usePrevalenceBreakdownStore = create<PrevalenceBreakdownState>()(set => ({
  prevalenceBreakdownRow: null,
  setPrevalenceBreakdownRow: row => set({ prevalenceBreakdownRow: row }),
}));
